import React, { Component } from "react";
import axios from "axios";
import { Redirect, Link } from "react-router-dom";
import { Button, Container, Grid, Typography, Snackbar, TextField } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import init from "../helpers/WindowToken";
import Constants from "../App/Variables/Constants";

export default class AddCategory extends Component {
  state = {
    title: "",
    category: null,
    preview: null,
    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({
        category: file,
        preview: URL.createObjectURL(file),
      });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (!this.state.title || !this.state.category) {
      this.setState({
        notification: true,
        message: "Title and Image required",
      });
      return;
    }
    const fd = new FormData();
    fd.append("title", this.state.title);
    fd.append("image", this.state.category);
    try {
      this.setState({ loading: true });
      if (init() === "success") {
        const response = await axios.post(Constants.postUrls.Addcategory, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        this.setState({
          loading: false,
          notification: true,
          message: response.data.message,
        });
        setTimeout(() => {
          this.setState({ redirect: true });
        }, 1500);
      }
    } catch (error) {
      this.setState({
        loading: false,
        notification: true,
        message: error?.response?.data?.message || "Upload failed",
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/category" />;
    }
    return (
      <Container maxWidth="xl">
        <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
          <Grid item xs={6}>
            <Typography variant="h5">Create Category</Typography>
          </Grid>
        </Grid>

        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={this.state.notification}
          autoHideDuration={3000}
          message={this.state.message}
          onClose={() => this.setState({ notification: false })}
        />

        <div style={{
          background: "#5b5757",
          padding: "20px",
          borderRadius: "10px",
          marginTop: "30px",
          marginBottom: "30px",
        }}>
          <div style={{
            background: "linear-gradient(60deg, rgb(128 115 115), rgb(255 250 250))",
            padding: "15px",
            marginTop: "-43px",
            borderRadius: "6px",
            width: "60px",
            textAlign: "center",
          }}>
            <EditIcon />
          </div>

          <form onSubmit={this.handleSubmit}>
            <Grid container spacing={3}>
              <Grid item sm={4}>
                <TextField
                  label="Category Title"
                  name="title"
                  value={this.state.title}
                  onChange={this.handleInput}
                  variant="outlined"
                  required
                  fullWidth
                />
              </Grid>

              <Grid item sm={4}>
                <input type="file" accept="image/*" onChange={this.handleFileChange} required />
                {this.state.preview && (
                  <img
                    src={this.state.preview}
                    alt="preview"
                    style={{ width: "120px", marginTop: "10px", borderRadius: "6px" }}
                  />
                )}
              </Grid>
            </Grid>

            <div style={{ marginTop: "30px" }}>
              <Button type="submit" variant="contained" color="primary" style={{ marginRight: "20px" }}>
                {this.state.loading ? "Adding..." : "Add Category"}
              </Button>
              <Link to="/category">
                <Button variant="contained" color="secondary">Cancel</Button>
              </Link>
            </div>
          </form>
        </div>
      </Container>
    );
  }
}
